<template>
    <div>
        <button
            @click="toggleCollapse"
            aria-label="CupCult AI"
            class="fixed bottom-4 right-4 bg-indigo-500 hover:bg-indigo-600 rounded-full text-white shadow-lg z-10 w-12 h-12 flex items-center justify-center cursor-pointer"
        >
            <Robot v-if="collapsed" class="transition-all duration-300 w-6 h-6" />
            <span v-else class="w-6 h-6" v-html="Cross"/>
        </button>

        <div
          key="social-links"
          class="fixed sm:right-4 z-20 transition-all duration-500 w-full sm:w-[370px] h-full sm:max-h-[590px] h-[calc(100%-120px)] bg-white border-black sm:border-2 rounded-xl"
          :class="collapsed ? '-bottom-full sm:-bottom-[590px]' : 'bottom-0 sm:bottom-20'"
        >
            <ChatWindow v-if="!collapsed" @close="toggleCollapse"/>
        </div>
    </div>
</template>

<script>
import Cross from "@/Components/Svg/Cross.svg?raw";
import Robot from '@/Components/Svg/Robot.svg';
import { defineAsyncComponent } from 'vue';

export default {
    components: {
        ChatWindow: defineAsyncComponent(() => import('@/Components/Chat/ChatWindow.vue')),
        Robot
    },
    setup() {
        return {
            Cross
        }
    },
    data() {
        return {
            collapsed: true,
        };
    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        }
    },
    created() {
        this.emitter.on('openAiChat', () => this.collapsed = false)
    }
};
</script>
